import { faCheck, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import Flag from 'react-world-flags'

const percentageFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

function UserProfileForm(props) {
    const [name, setName] = useState(() => localStorage.getItem("nome") || "");
    const [email, setEmail] = useState(localStorage.getItem("email") || "");
    const [alterarSenha, setAlterarSenha] = useState(false);
    const [password, setPassword] = useState(localStorage.getItem("password") || "");
    const [confirmPassword, setConfirmPassword] = useState(localStorage.getItem("confirmPassword") || "");
    const [fixa, setFixa] = useState(localStorage.getItem("fixa") || 30);
    const [acoes, setAcoes] = useState(localStorage.getItem("acoes") || 25);
    const [fiis, setFiis] = useState(localStorage.getItem("fiis") || 15);
    const [stocks, setStocks] = useState(localStorage.getItem("stocks") || 15);
    const [etfs, setEtfs] = useState(localStorage.getItem("etfs") || 10);
    const [reits, setReits] = useState(localStorage.getItem("reits") || 5);
    const [tolerancy, setTolerancy] = useState(localStorage.getItem("tolerancy") || 1);
    const [threshold, setthreshold] = useState(localStorage.getItem("threshold") || 2);
    const [sum, setSum] = useState((fixa / 100 + acoes / 100 + fiis / 100 + stocks / 100 + etfs / 100 + reits / 100) || 1);
    const [dollar, setDollar] = useState(localStorage.getItem("dollar") || 0);

    const nameValidationPattern = /^[A-Za-zÀ-ÿ]+( [A-Za-zÀ-ÿ]+)+$/;
    const emailValidationPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    const passwordValidationPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;

    const [validated, setValidated] = useState(false);

    useEffect(() => {
        localStorage.setItem("nome", name);
    }, [name]);

    useEffect(() => {
        setSum(fixa / 100 + acoes / 100 + fiis / 100 + stocks / 100 + etfs / 100 + reits / 100);
    }, [fixa, acoes, fiis, stocks, etfs, reits]);

    async function fetchDollarCurrent() {
        try {
            const response = await fetch(
                'https://investidorlibertario.terradata.com.br/api/quotations/dollar.php'
            );

            if (!response.ok) {
                throw new Error('Erro ao obter cotação do dólar');
            }

            const data = await response.json();
            const value = data.value;
            console.warn(value)

            // ajuste o campo conforme o retorno real da API
            const dollarCurrent = data.dollar ?? data.value ?? data;

            localStorage.setItem('dollarCurrent', dollarCurrent);

            return dollarCurrent;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            console.log("opa");
            event.preventDefault();
            event.stopPropagation();
        }
        console.log("aipo");

        // setValidated(true);
        // return;
        const userProfile = {
            name,
            email,
            fixa,
            acoes,
            stocks,
            fiis,
            etfs,
            reits,
            tolerancy,
            threshold,
            dollar,
            password,
            confirmPassword
        };
        console.log(userProfile);

        if (alterarSenha) {
            if (password === confirmPassword) {
                userProfile['password'] = password;
                userProfile['confirmPassword'] = confirmPassword;
            } else {// senhas nao coincidem
                alert("As senhas não coincidem.");
            }
        }
        localStorage.setItem('dollar', dollar);

        props.submitHandler(userProfile);
    };

    const passwordVerify = () => {
        return password === confirmPassword
    };

    useEffect(() => {
        setDollar(localStorage.getItem("dollar"));
        fetchDollarCurrent();
    }, []);

    return (
        <Container className="mt-5">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                {/* Informações Básicas */}
                <h5>Informações Básicas</h5>
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formName">
                            <Form.Label>Nome completo:</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Digite seu nome"
                                value={name}
                                pattern={nameValidationPattern}
                                required
                                isInvalid={!nameValidationPattern.test(name)}
                                isValid={nameValidationPattern.test(name)}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> Forneça um nome inválido.</small></Form.Control.Feedback>
                            <Form.Control.Feedback><small><FontAwesomeIcon icon={faCheck} /> Nome válido.</small></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formEmail">
                            <Form.Label>Email:</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Digite seu email"
                                value={email}
                                required
                                isInvalid={!emailValidationPattern.test(email)}
                                isValid={emailValidationPattern.test(email)}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> Forneça um endereço válido.</small></Form.Control.Feedback>
                            <Form.Control.Feedback><small><FontAwesomeIcon icon={faCheck} /> Endereço válido.</small></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className='mb-3'>
                    {props.editPassword &&
                        <Col md={2}>
                            <Form.Group controlId="formAlterarSenha" className="mt-2">
                                <Form.Check
                                    type="checkbox"
                                    label="Alterar senha"
                                    checked={alterarSenha}
                                    onChange={(e) => setAlterarSenha(e.target.checked)}
                                />
                            </Form.Group>
                        </Col>
                    }
                    <Col md={props.editPassword ? 5 : 6}>
                        <Form.Group controlId="formPassword">
                            <Form.Label>Senha:</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Digite sua senha"
                                value={password}
                                required
                                isInvalid={!passwordValidationPattern.test(password)}
                                isValid={passwordValidationPattern.test(password)}
                                disabled={!alterarSenha && props.editPassword}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            {(alterarSenha || !props.edit) && <>
                                <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> A senha deve conter ao menos 8 caracteres entre eles 1 letra minúscula, 1 letra maiúscula e 1 número.</small></Form.Control.Feedback>
                                <Form.Control.Feedback type="valid"><small><FontAwesomeIcon icon={faCheck} /> Senha válida.</small></Form.Control.Feedback>
                            </>}
                            {(props.edit && !alterarSenha) && <>
                                <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> A senha não será alterada.</small></Form.Control.Feedback>
                            </>}
                        </Form.Group>
                    </Col>
                    <Col md={props.editPassword ? 5 : 6}>
                        <Form.Group controlId="formConfirmPassword">
                            <Form.Label>Confirme sua Senha:</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Confirme sua senha"
                                value={confirmPassword}
                                required
                                isInvalid={!passwordValidationPattern.test(confirmPassword) || !passwordVerify()}
                                isValid={passwordValidationPattern.test(confirmPassword) && passwordVerify()}
                                disabled={!alterarSenha && props.editPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            {(alterarSenha || !props.edit) && <>
                                {passwordValidationPattern.test(confirmPassword) && !passwordVerify() ? (
                                    <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> As senhas devem coincidir.</small></Form.Control.Feedback>
                                ) : (
                                    <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> A senha deve conter ao menos 8 caracteres entre eles 1 letra minúscula, 1 letra maiúscula e 1 número.</small></Form.Control.Feedback>
                                )}
                                <Form.Control.Feedback type="valid"><small><FontAwesomeIcon icon={faCheck} /> Confirmação de senha válida.</small></Form.Control.Feedback>
                            </>}
                        </Form.Group>
                    </Col>
                </Row>

                {/* Perfil de Investidor */}
                <h5>Perfil de Investidor</h5>
                <Row>
                    <Col md={2}>
                        <Form.Group controlId="formFixedIncome">
                            <Form.Label><Flag code="bra" height="15" />&nbsp;Renda Fixa (%):</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Renda Fixa"
                                value={fixa}
                                step="0.01"
                                min="0"
                                max="100"
                                isValid={sum === 1}
                                onChange={(e) => setFixa(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group controlId="formAcoes">
                            <Form.Label><Flag code="bra" height="15" />&nbsp;Ações (%):</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Ações (Brasil)"
                                value={acoes}
                                step="0.01"
                                min="0"
                                max="100"
                                isValid={sum === 1}
                                onChange={(e) => setAcoes(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group controlId="formFiis">
                            <Form.Label><Flag code="bra" height="15" />&nbsp;FIIs (%):</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="FIIs"
                                value={fiis}
                                step="0.01"
                                min="0"
                                max="100"
                                isValid={sum === 1}
                                onChange={(e) => setFiis(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group controlId="formStocks">
                            <Form.Label><Flag code="usa" height="13" />&nbsp;Stocks (%):</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Stocks (EUA)"
                                value={stocks}
                                step="0.01"
                                min="0"
                                max="100"
                                isValid={sum === 1}
                                onChange={(e) => setStocks(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group controlId="formEtfs">
                            <Form.Label><Flag code="usa" height="13" />&nbsp;ETFs (%):</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="ETFs"
                                value={etfs}
                                step="0.01"
                                min="0"
                                max="100"
                                isValid={sum === 1}
                                onChange={(e) => setEtfs(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group controlId="formReits">
                            <Form.Label><Flag code="usa" height="13" />&nbsp;REITs (%):</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="REITs"
                                value={reits}
                                step="0.01"
                                min="0"
                                max="100"
                                isValid={sum === 1}
                                onChange={(e) => setReits(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col md={12}>
                        <small className="fw-bold">Total: <span className={sum === 1 ? "text-success" : "text-danger"}>{percentageFormatter.format(sum)}</span></small>
                    </Col>
                </Row>

                {/* Tolerância e percentual limite para ativos */}
                <Row>
                    <Col md={2}>
                        <Form.Group className="mb-3" controlId="formTolerancy">
                            <Form.Label>Tolerância (%):</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Tolerância"
                                value={tolerancy}
                                step="0.01"
                                min="0"
                                max="100"
                                isValid={tolerancy >= 0 && tolerancy <= 100}
                                onChange={(e) => setTolerancy(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group className="mb-3" controlId="formLimit">
                            <Form.Label>Concentração Limite (%):</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Limite"
                                value={threshold}
                                step="0.01"
                                min="0"
                                max="100"
                                isValid={tolerancy >= 0 && tolerancy <= 100}
                                onChange={(e) => setthreshold(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        <Form.Group className="mb-3" controlId="formAverageDollarPrice">
                            <Form.Label>Preço Médio do Dólar:</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Digite o preço médio do dólar"
                                value={dollar}
                                min="0"
                                step="0.01"
                                isValid={dollar > 0}
                                onChange={(e) => setDollar(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                {/* Preço Médio do Dólar */}
                <Row className="mb-3">
                    <Col md={8}>
                        <small>Valores utilizados como referência para notificações relacionadas à concentração em um ativo ou classe.</small>
                    </Col>
                    <Col md={4} className="text-end">
                        <small>Valor utilizado para ajuste do cálculo do ágio.</small>
                    </Col>
                </Row>

                <Button variant="primary" type="submit"><FontAwesomeIcon icon={faSave} />&nbsp;Salvar</Button>
            </Form>
        </Container>
    );
}

export default UserProfileForm;
